// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"dcf73b4c","802":"d75a4a53"}[chunkId] + ".chunk.js";
};